function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue";
var _hoisted_1 = ["id"];
var _hoisted_2 = ["id", "data-cy"];
var _hoisted_3 = ["data-idx", "loading", "alt", "width", "height", "onLoad"];
var _hoisted_4 = ["id"];
var _hoisted_5 = ["loading", "alt"];
import { Swiper } from "swiper";
import { Zoom } from "swiper/modules";
// import Swiper and modules styles
import "swiper/css/bundle";
//Zoom module not only allow us to auto center the images, but it will also center the images!
import "swiper/css/zoom";
//@ts-ignore
import { shallowCopyObjectTo } from "@utils/ObjectUtils";
import { reactive, computed, onMounted, ref, nextTick } from "vue";
export default /*#__PURE__*/_defineComponent(Object.assign({
  inheritAttrs: false
}, {
  __name: 'SwiperCarousel',
  props: {
    id: {},
    swiperOptions: {},
    thumbSwiperOptions: {},
    lazyLoadImages: {
      type: Boolean,
      "default": true
    },
    backgroundImage: {
      type: Boolean,
      "default": false
    },
    images: {},
    artDirection: {},
    shiftFirstImage: {
      type: Boolean,
      "default": false
    }
  },
  emits: ["moved", "click", "firstSlideLoaded"],
  setup: function setup(__props, _ref) {
    var _this = this;
    var __expose = _ref.expose,
      __emit = _ref.emit;
    //@ts-ignore
    var props = __props;
    var emits = __emit;
    var state = reactive({
      swiperParams: {
        modules: [Zoom]
      },
      swiper: null,
      initCarousel: false
    });
    var swiperWrapper = ref();
    var sliderSlidePerView = computed(function () {
      var _a;
      return ((_a = props.swiperOptions) === null || _a === void 0 ? void 0 : _a.slidesPerView) || 1;
    });
    var thumbSlidePerView = computed(function () {
      var _a;
      return ((_a = props.thumbSwiperOptions) === null || _a === void 0 ? void 0 : _a.slidesPerView) || 1;
    });
    var keyboardControl = computed(function () {
      var _a;
      return !!((_a = props.swiperOptions) === null || _a === void 0 ? void 0 : _a.keyboard);
    });
    var navigation = computed(function () {
      var swiperOptions = props.swiperOptions;
      if (!swiperOptions) return false;
      return !!swiperOptions.navigation;
    });
    var pagination = computed(function () {
      var swiperOptions = props.swiperOptions;
      if (!swiperOptions) return false;
      return !!swiperOptions.pagination;
    });
    var autoplay = computed(function () {
      var swiperOptions = props.swiperOptions;
      if (!swiperOptions) return false;
      return !!swiperOptions.autoplay;
    });
    var effect = computed(function () {
      var _a;
      return ((_a = props.swiperOptions) === null || _a === void 0 ? void 0 : _a.effect) || "slider";
    });
    var setSwiperOptions = function setSwiperOptions() {
      if (!props.swiperOptions) return;
      shallowCopyObjectTo(props.swiperOptions, state.swiperParams);
    };
    var imgAttributes = function imgAttributes(image) {
      var idx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
      if (!image.images)
        //By default, we will use the src given in input
        return {
          src: image.src || ""
        };
      var src = "";
      var srcset = "";
      var sizes = "";
      if (props.artDirection) {
        for (var bp in props.artDirection) {
          var _props$artDirection$b = props.artDirection[bp],
            mq = _props$artDirection$b.mq,
            width = _props$artDirection$b.width;
          if (!width) continue;
          sizes += sizes ? ",".concat(mq, " ").concat(parseInt(width), "px") : "".concat(mq, " ").concat(parseInt(width), "px");
        }
        srcset = image.images.reduce(function (acc, img, idx) {
          var bp = Object.values(props.artDirection)[idx];
          if (!bp || !bp.width) return acc;
          acc += acc ? ", ".concat(img.storagePath, " ").concat(bp.width) : "".concat(img.storagePath, " ").concat(bp.width);
          return acc;
        }, "");
        src = image.images[0].storagePath;
      } else {
        /* Special case: insertion  */
        var images = image.images;
        if (image.images.length > 3) images = image.images.slice(2, 5);else {
          if (props.shiftFirstImage)
            //Shifting the first image since it has too low resolution
            images[0] = images[1];
        }
        srcset = images.reduce(function (acc, img, idx) {
          if (idx === 0) src = "".concat(img.storagePath);
          if (idx > 0) acc += ", ";
          return "".concat(acc).concat(img.storagePath, " ").concat(idx + 1, "x");
        }, "");
      }
      //Preparing manual lazy loading
      var dataSrc = src;
      var dataSrcset = srcset;
      if (typeof sliderSlidePerView.value === "number" && idx > sliderSlidePerView.value) {
        src = "";
        srcset = "";
        return _defineProperty(_defineProperty({
          sizes: sizes
        }, "data-src", dataSrc), "data-srcset", dataSrcset);
      } else {
        return {
          src: src,
          srcset: srcset,
          sizes: sizes
        };
      }
    };
    var imagesRefs = [];
    var handleMovedSlide = function handleMovedSlide(curIndex) {
      var _a;
      if (typeof sliderSlidePerView.value == "string") return;
      var curImg = imagesRefs[curIndex];
      //It may happen that, when having the thumbnail, the current image has not been loaded yet...
      if (curImg && !curImg.src) {
        curImg.src = curImg.dataset.src || "";
        curImg.srcset = curImg.dataset.srcset || "";
      }
      if (curIndex < sliderSlidePerView.value || curIndex + 1 >= ((_a = props.images) !== null && _a !== void 0 ? _a : []).length) return;
      //Manually loading the x + 1 slide
      var img = imagesRefs[curIndex + 1];
      if (img && !img.src) {
        img.src = (img === null || img === void 0 ? void 0 : img.dataset.src) || "";
        img.srcset = (img === null || img === void 0 ? void 0 : img.dataset.srcset) || "";
      }
    };
    __expose({
      moveTo: function moveTo(index) {
        var speed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var runCallbacks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        state.swiper && state.swiper.slideTo(index, speed, runCallbacks);
      }
    });
    var root = ref(null);
    var handleLoad = function handleLoad(idx) {
      if (idx === 0 && imagesRefs && imagesRefs[idx]) nextTick(function () {
        var _a;
        //Setting a data-attribute to the root element to get the info about the first loaded element
        (_a = root.value) === null || _a === void 0 ? void 0 : _a.setAttribute("data-first-slide-loaded", "true");
        emits("firstSlideLoaded");
      });
    };
    onMounted(function () {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _yield$import, Keyboard, _yield$import2, Pagination, _yield$import3, Navigation, navigationClasses, _yield$import4, Autoplay, sliderProps, thumbSwiper, _yield$import5, Thumbs, FreeMode, Controller;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              setSwiperOptions();
              if (!keyboardControl.value) {
                _context.next = 8;
                break;
              }
              _context.next = 4;
              return import("swiper/modules");
            case 4:
              _yield$import = _context.sent;
              Keyboard = _yield$import.Keyboard;
              (_a = state.swiperParams.modules) === null || _a === void 0 ? void 0 : _a.push(Keyboard);
              state.swiperParams.keyboard = props.swiperOptions.keyboard;
            case 8:
              if (!pagination.value) {
                _context.next = 17;
                break;
              }
              _context.next = 11;
              return import("swiper/modules");
            case 11:
              _yield$import2 = _context.sent;
              Pagination = _yield$import2.Pagination;
              (_b = state.swiperParams.modules) === null || _b === void 0 ? void 0 : _b.push(Pagination);
              /* Importing pagination CSS */
              //@ts-ignore
              _context.next = 16;
              return import("swiper/css/pagination");
            case 16:
              /* Importing definitions */
              state.swiperParams.pagination = Object.assign({
                el: ".swiper-pagination",
                renderFraction: function renderFraction(currentClass, totalClass) {
                  return "<div class=\"tw-rounded-xs tw-border-w-black tw-border tw-border-solid tw-px-3 tw-bg-white tw-pt-[3px] tw-pb-[3px]\">\n                    <span data-cy=\"swiper-pagination-current\" class=\"".concat(currentClass, "\"></span>\n                    /\n                    <span data-cy=\"swiper-pagination-total\" class=\"").concat(totalClass, "\"></span>\n                 </div>");
                }
              }, state.swiperParams.pagination);
            case 17:
              if (!navigation.value) {
                _context.next = 27;
                break;
              }
              _context.next = 20;
              return import("swiper/modules");
            case 20:
              _yield$import3 = _context.sent;
              Navigation = _yield$import3.Navigation;
              (_c = state.swiperParams.modules) === null || _c === void 0 ? void 0 : _c.push(Navigation);
              /* Importing pagination */
              //@ts-ignore
              _context.next = 25;
              return import("swiper/css/navigation");
            case 25:
              navigationClasses = Object.assign(Object.assign({}, (_d = props.swiperOptions.navigation.nextEl) !== null && _d !== void 0 ? _d : {
                nextEl: ".swiper-button-next"
              }), (_e = props.swiperOptions.navigation.prevEl) !== null && _e !== void 0 ? _e : {
                prevEl: ".swiper-button-prev"
              });
              state.swiperParams.navigation = Object.assign(Object.assign({}, props.swiperOptions.navigation), navigationClasses);
            case 27:
              if (!autoplay.value) {
                _context.next = 36;
                break;
              }
              _context.next = 30;
              return import("swiper/modules");
            case 30:
              _yield$import4 = _context.sent;
              Autoplay = _yield$import4.Autoplay;
              (_f = state.swiperParams.modules) === null || _f === void 0 ? void 0 : _f.push(Autoplay);
              //@ts-ignore
              _context.next = 35;
              return import("swiper/css/autoplay");
            case 35:
              state.swiperParams.autoplay = props.swiperOptions.autoplay;
            case 36:
              /* The props of the main slider */
              sliderProps = Object.assign(Object.assign({}, state.swiperParams), {
                on: {
                  slideChange: function slideChange(swiper) {
                    handleMovedSlide(swiper.activeIndex);
                    emits("moved", {
                      activeIndex: swiper.activeIndex
                    });
                  }
                }
              });
              /* Initializing thumb so we can pass it to the main swiper */
              thumbSwiper = null;
              if (!props.thumbSwiperOptions) {
                _context.next = 55;
                break;
              }
              _context.next = 41;
              return import("swiper/modules");
            case 41:
              _yield$import5 = _context.sent;
              Thumbs = _yield$import5.Thumbs;
              FreeMode = _yield$import5.FreeMode;
              Controller = _yield$import5.Controller;
              (_g = state.swiperParams.modules) === null || _g === void 0 ? void 0 : _g.push(Thumbs);
              (_h = state.swiperParams.modules) === null || _h === void 0 ? void 0 : _h.push(Controller);
              /* Importing css */
              //@ts-ignore
              _context.next = 49;
              return import("swiper/css/thumbs");
            case 49:
              _context.next = 51;
              return import("swiper/css/free-mode");
            case 51:
              _context.next = 53;
              return import("swiper/css/controller");
            case 53:
              thumbSwiper = new Swiper("#thumb_".concat(props.id), Object.assign(Object.assign({}, props.thumbSwiperOptions), {
                modules: [FreeMode]
              }));
              sliderProps.thumbs = {
                swiper: thumbSwiper
              };
            case 55:
              sliderProps.lazyPreloadPrevNext = 1;
              state.swiper = new Swiper("#".concat(props.id), sliderProps);
              //In case the swiper wrapper has tw-hidden (useful to avoid showing the first image in a modal gallery) we need to remove it
              //when the carousel has loaded
              (_j = swiperWrapper.value) === null || _j === void 0 ? void 0 : _j.classList.remove("tw-hidden");
            case 58:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        id: "root-".concat(_ctx.id),
        ref_key: "root",
        ref: root,
        "class": _normalizeClass(["swiper-carousel-root", _ctx.$attrs['root-classes']])
      }, [_createCommentVNode(" Slider main container "), _createElementVNode("div", {
        id: _ctx.id,
        "data-cy": _ctx.$attrs['data-cy'],
        "class": _normalizeClass(["swiper", _ctx.$attrs['swiper-classes']])
      }, [_createCommentVNode(" Additional required wrapper "), _createElementVNode("div", {
        ref_key: "swiperWrapper",
        ref: swiperWrapper,
        "class": _normalizeClass(["swiper-wrapper", [_ctx.$attrs['swiper-wrapper-classes'], effect.value === 'none' && 'no-transition']]),
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return emits('click');
        })
      }, [_createCommentVNode(" Slides "), _renderSlot(_ctx.$slots, "swiper_slide", {}, function () {
        return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, function (image, idx) {
          return _openBlock(), _createElementBlock("div", {
            key: "swiper_".concat(_ctx.id, "_").concat(idx),
            "class": _normalizeClass(["swiper-slide", _ctx.$attrs['swiper-slide-classes']])
          }, [_createElementVNode("div", {
            "class": _normalizeClass(["swiper-zoom-container", _ctx.$attrs['swiper-zoom-container-classes']])
          }, [!_ctx.backgroundImage ? (_openBlock(), _createElementBlock("img", _mergeProps({
            key: 0,
            ref_for: true,
            ref: function ref(el) {
              return imagesRefs.push(el);
            },
            "class": ["disable-select", [_ctx.$attrs['slide-img-classes'] || image.classes]],
            "data-idx": "".concat(_ctx.id, "-slide-img-").concat(idx)
          }, imgAttributes(image, idx), {
            loading: _ctx.lazyLoadImages ? 'lazy' : idx >= sliderSlidePerView.value ? 'lazy' : '',
            alt: image.alt,
            itemprop: "image",
            width: image.width,
            height: image.height,
            onLoad: function onLoad($event) {
              return handleLoad(idx);
            }
          }), null, 16 /* FULL_PROPS */, _hoisted_3)) : _createCommentVNode("v-if", true)], 2 /* CLASS */)], 2 /* CLASS */);
        }), 128 /* KEYED_FRAGMENT */))];
      })], 2 /* CLASS */), _createCommentVNode(" If we need pagination "), pagination.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": _normalizeClass([_ctx.$attrs['swiper-pagination-classes'], "swiper-pagination [&.swiper-pagination-fraction]:tw-flex [&.swiper-pagination-fraction]:tw-justify-center"]),
        onClick: _cache[1] || (_cache[1] = _withModifiers(function () {}, ["stop"]))
      }, null, 2 /* CLASS */)) : _createCommentVNode("v-if", true), _createCommentVNode(" If we need navigation buttons "), navigation.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("div", {
        "class": "swiper-button-prev",
        "data-cy": "swiper-button-prev",
        onClick: _cache[2] || (_cache[2] = _withModifiers(function () {}, ["stop"]))
      }), _createElementVNode("div", {
        "class": "swiper-button-next",
        "data-cy": "swiper-button-next",
        onClick: _cache[3] || (_cache[3] = _withModifiers(function () {}, ["stop"]))
      })], 64 /* STABLE_FRAGMENT */)) : _createCommentVNode("v-if", true), _createCommentVNode(" If we need scrollbar "), _createCommentVNode("    <div class=\"swiper-scrollbar\" />")], 10 /* CLASS, PROPS */, _hoisted_2), _ctx.thumbSwiperOptions ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        id: "thumb_".concat(_ctx.id),
        thumbsSlider: "",
        "class": _normalizeClass(["swiper", _ctx.$attrs['thumb-swiper-classes']])
      }, [_createElementVNode("div", {
        "class": _normalizeClass(["swiper-wrapper", _ctx.$attrs['thumb-swiper-wrapper-classes']])
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, function (image, idx) {
        return _openBlock(), _createElementBlock("div", {
          key: "thumb_".concat(_ctx.id, "_").concat(idx),
          "class": _normalizeClass(["swiper-slide", _ctx.$attrs['thumb-img-wrapper-classes']])
        }, [_createElementVNode("img", _mergeProps({
          "class": _ctx.$attrs['thumb-img-classes']
        }, imgAttributes(image), {
          loading: idx >= thumbSlidePerView.value ? 'lazy' : '',
          alt: image.alt
        }), null, 16 /* FULL_PROPS */, _hoisted_5)], 2 /* CLASS */);
      }), 128 /* KEYED_FRAGMENT */))], 2 /* CLASS */)], 10 /* CLASS, PROPS */, _hoisted_4)) : _createCommentVNode("v-if", true)], 10 /* CLASS, PROPS */, _hoisted_1);
    };
  }
}));